import React from 'react';
import i18n from 'i18next';

const MenuDrawerSubItem = ({ menu, onClick }) => {
    const name =
        menu.names?.find((item) => item.langCode === i18n.language)?.name ||
        menu.names?.[0]?.name ||
        '';

    return (
        <div>
            <div
                onClick={onClick}
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    padding: '13px 20px',
                    cursor: 'pointer',
                    borderBottom: '1px solid #f3f4f6',
                    transition: 'background .12s',
                }}
                onMouseEnter={(e) => (e.currentTarget.style.background = '#f9fafb')}
                onMouseLeave={(e) => (e.currentTarget.style.background = 'transparent')}
            >
                <span style={{ fontSize: 14, color: '#374151', fontWeight: 400 }}>{name}</span>
            </div>
            {menu.children?.map((m, ind) => (
                <div key={ind} style={{ paddingLeft: 16 }}>
                    <MenuDrawerSubItem menu={m} onClick={onClick} />
                </div>
            ))}
        </div>
    );
};

export default MenuDrawerSubItem;
